import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import darkTheme from "../../style/theme";
import LeftDrawer from "../../components/LeftDrawer";
import { useSession } from '../../contexts/SessionContext';
import DashboardHome from "../../components/dashboard/DashboardHome";
import UserGuide from "../../components/userguide/UserGuide";
import { UnsavedChangesProvider } from "../../contexts/UnsavedChangesContext";

const Dashboard = () => {
  const { isDrawerOpen } = useSession();
  const location = useLocation();

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {/* Shared with LeftDrawer so a nav-item click can ask the currently
          mounted page (e.g. scene edit) whether it's safe to navigate away. */}
      <UnsavedChangesProvider>
        <LeftDrawer />

        <Box sx={{
          // OPUS-913: flush sidebar (260px, no floating margin) — content sits
          // immediately to its right with no gap or body radius.
          width: isDrawerOpen ? 'calc(100% - 260px)' : '100%',
          ml: isDrawerOpen ? '260px' : '0',
          height:'calc(100vh)',
          p:'.5em',
          overflow:'hidden',
          mb:1,
          borderRadius: 0
        }}>
          {location.pathname === '/dashboard' ? (
            <DashboardHome />
          ) : (
            <Outlet />
          )}
        </Box>
      </UnsavedChangesProvider>
      <UserGuide />
    </ThemeProvider>
  );
};

export default Dashboard;